export const CLIENT_FETCH_INIT = 'CLIENT_FETCH_INIT';
export const CLIENT_FETCH_SUCCESS = 'CLIENT_FETCH_SUCCESS';
export const CLIENT_FETCH_ERROR = 'CLIENT_FETCH_ERROR';

export const CLIENT_POST_INIT = 'CLIENT_POST_INIT';
export const CLIENT_POST_SUCCESS = 'CLIENT_POST_SUCCESS';
export const CLIENT_POST_ERROR = 'CLIENT_POST_ERROR';

export const CLIENT_RESET = 'CLIENT_RESET';
